"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Group = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var clsx_1 = tslib_1.__importDefault(require("clsx"));
var react_select_1 = require("react-select");
var set_1 = tslib_1.__importDefault(require("lodash/fp/set"));
exports.Group = function (props) {
    var selectProps = props.selectProps, label = props.label, data = props.data;
    var _a = data.underlined, underlined = _a === void 0 ? false : _a;
    var expandableGroups = selectProps.expandableGroups, isGrouped = selectProps.isGrouped;
    var isGroup = label !== '';
    var groupProps = set_1.default('headingProps.data', data, props);
    return (react_1.default.createElement(react_select_1.components.Group, tslib_1.__assign({ className: clsx_1.default({
            expandableGroupEnabled: expandableGroups && isGrouped,
            expandableGroupDisabled: expandableGroups && !isGrouped,
            expandable: expandableGroups && isGroup && isGrouped,
            collapsed: expandableGroups && isGroup && isGrouped,
            underlined: underlined,
        }) }, groupProps)));
};
exports.Group.displayName = 'FOS_ReactSelect_Group';
